var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VFlex',[_c('VTextField',{attrs:{"label":_vm.$nt('label'),"error-messages":_vm.emailError,"value":_vm.value,"rules":[_vm.$rules.isRequired, _vm.$rules.isValidEmail]},on:{"input":function (email) { return _vm.$emit('input', email); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }